import logoAntai from '@static/vectors/logos/logo_antai.svg'
import logoBizum from '@static/vectors/logos/logo_bizum.svg'
import logoCabify from '@static/vectors/logos/logo_cabify.svg'
import logoCex from '@static/vectors/logos/logo_cex.svg'
import logoCyberclick from '@static/vectors/logos/logo_cyberclick.svg'
import logoIsdi from '@static/vectors/logos/logo_isdi.svg'
import logoMoodin from '@static/vectors/logos/logo_moodin.svg'
import logoMultiverseComputing from '@static/vectors/logos/logo_multiverse-computing.svg'
import logoGlue from '@static/vectors/logos/logo_glue-digital.svg'
import logoEmergia from '@static/vectors/logos/logo_emergia.svg'
import logoEntradas from '@static/vectors/logos/logo_entradas-com.png'
import logoMs from '@static/vectors/logos/logo_ms.png'
import logoDes from '@static/vectors/logos/logo_destinia.png'
import logoIbm from '@static/vectors/logos/logo_ibm.png'
import logoAccom from '@static/vectors/logos/logo_accom.png'
// import logoAtdinamica from '@static/vectors/logos/logo_artdinamica.png'

export const logos = {
  antai: logoAntai,
  bizum: logoBizum,
  cabify: logoCabify,
  cex: logoCex,
  cyberclick: logoCyberclick,
  isdi: logoIsdi,
  moodin: logoMoodin,
  multiverseComputing: logoMultiverseComputing,
  emergia: logoEmergia,
  glue: logoGlue,
  entradasCom: logoEntradas,
  ms: logoMs,
  destinia: logoDes,
  ibm: logoIbm,
  accom: logoAccom
  // artdinamica: logoAtdinamica
}
